import Service from '@/services/abstract/service'

export default class LayoutArquivo extends Service {

  constructor() {
    super()

    this._layoutCollection = this._db.collection(`${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/LayoutArquivo`)
    this._campanhasCollection = this._db.collection(`${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Campanhas`)
  }

  async list(campanhas, ativo) {
    try{
      let layouts = []

      for(let currentCampanha of campanhas) {
        let querySnapshot = await this._layoutCollection.where('campanha', '==', currentCampanha).where('ativo', '==', ativo).get()
        let campanhaQuerySnapshot = await this._campanhasCollection.doc(currentCampanha).get()
        let campanhaInfo = campanhaQuerySnapshot.exists ? campanhaQuerySnapshot.data() : { nome: '' }

        if(!querySnapshot.empty){
          for(let queryDoc of querySnapshot.docs) {
            let layout = {
              id: queryDoc.id,
              campanhaNome: campanhaInfo.nome,
              ...queryDoc.data(),
            }
            layouts.push(layout)
          }
        }
      }

      return Promise.resolve(layouts)
    }catch(error){
      return Promise.reject(error)
    }
  }

  async updateAtivo(layoutId, ativo){
    try{
      await this._layoutCollection.doc(layoutId).update({ ativo })

      const arquivos = await this._db.collectionGroup('Arquivos')
        .where('layoutId', '==', layoutId)
        .where('ativo', '==', !ativo)
        .get()

      if (!arquivos.empty) {
        await this._db.runTransaction(async t => {
          for (const arquivo of arquivos.docs) {
            const [prefix, _] = arquivo.ref.path.split('-')
            if (prefix === this._prefix) {
              if (!ativo) {
                await t.update(arquivo.ref, { ativo, dataDesativacao: new Date() })
              } else {
                await t.update(arquivo.ref, { ativo, dataDesativacao: null })
              }
            }
          }
        })
      }
      return Promise.resolve()
    }catch(error){
      console.error(error)
      return Promise.reject(error)
    }
  }
}
